// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown-button[data-v-6e022ce9]{color:var(--color-body-text);font-weight:var(--font-weight-4)}.dropdown-button[data-v-6e022ce9]:focus,.dropdown-button[data-v-6e022ce9]:hover{color:var(--color-primary)}.arrow[data-v-6e022ce9]{height:1em;transition:var(--animation-speed-1) transform var(--ease-out-2);vertical-align:middle;width:.75em}.arrow path[data-v-6e022ce9]{fill:var(--color-primary)}.arrow.is-expanded[data-v-6e022ce9]{transform:rotate(180deg)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
